import React from 'react';
import styled from '@emotion/styled';
import { getColumnDef, getInspectionColumnDef } from './constants';
import { DownOutlined, UpOutlined } from '@ant-design/icons';
import Table from 'app/components/Table';
import { useNavigate } from 'react-router';
import { JobFilter } from '../../JobFilter';
import { PaginationProps } from 'antd';
import SubPO from 'app/pages/JobDetail/components/Tabs/Reports/components/SubPO';

const Container = styled.div`
  margin-top: 23px;
  border-radius: 4px;
  box-shadow: 0px 1px 6px 0px #a5b2c833;
  box-shadow: 0px 2px 4px 1px #a5b2c81a;
  background: #fff;
  padding: 24px;
  tbody .ant-table-cell {
    cursor: pointer;
  }

  .ant-table-expanded-row {
    > td {
      background: rgba(250, 252, 255, 1);
    }
  }
`;
const SubTable = styled(Table)`
  thead {
    background: rgba(235, 241, 255, 1);

    th {
      font-size: 12px;
      font-weight: 400;
      line-height: 16px;
      letter-spacing: 0.005em;
      text-align: left;

      &:before {
        display: none;
      }
    }
  }
  .ant-table-expand-icon-col,
  .ant-table-row-expand-icon-cell {
    display: none !important;
  }
  .ant-table-expanded-row .ant-table-cell {
    padding: 0;
  }
`;

const StyledTotalLabel = styled.p`
  font-size: 12px;
  font-weight: 400;
  letter-spacing: 0.005em;
  text-align: left;
  color: #8991a0;
`;

type Props = {
  keywords?: string;
  pagination?: PaginationProps;
  data: any[];
  loading?: boolean;
  onChange: (
    filter: { [key: string]: any },
    sort: {
      [key: string]: any;
    },
    pagination: PaginationProps
  ) => void;
};

export const Job = (props: Partial<Props>) => {
  const { data, pagination, loading, onChange } = props;
  const [filtered, setFiltered] = React.useState({
    status: [],
    result: [],
    typeOfService: []
  });
  const [sorter, setSorter] = React.useState({
    value: 'inspectionDate',
    direction: 'desc'
  });
  const navigate = useNavigate();

  const onPaginationChange = (pagination: PaginationProps) => {
    onChange(filtered, sorter, pagination);
  };

  const onChangeSort = (sorter: {
    value: string;
    direction: 'desc' | 'asc';
  }) => {
    setSorter(sorter);
    onChange(filtered, sorter, pagination);
  };
  const onChangeFilter = (filter: Record<string, string[]>) => {
    setFiltered(filter as any);
    onChange(filter, sorter, pagination);
  };

  return (
    <div>
      <JobFilter
        onChangeFilter={onChangeFilter}
        onChangeSort={onChangeSort}
        filtered={filtered}
        sorter={sorter as any}
      ></JobFilter>
      <Container>
        <Table
          loading={loading}
          scroll={{ x: '80vw' }}
          rowKey={(record) => record.id}
          dataSource={data}
          columns={getColumnDef()}
          onChange={onPaginationChange}
          pagination={{
            ...pagination,
            current: pagination.current,
            total: pagination.total,
            showSizeChanger: true,
            showTotal: (total, range) => {
              return (
                <StyledTotalLabel>
                  {range[0]}-{range[1]} of {total}
                </StyledTotalLabel>
              );
            }
          }}
          onRow={(record) => {
            return {
              onClick: () => {
                navigate(`job/${record.id}`);
              }
            };
          }}
          expandable={{
            expandedRowRender: (record) => {
              return (
                <div>
                  <SubTable
                    pagination={false}
                    columns={getInspectionColumnDef()}
                    dataSource={
                      record?.inspectionPOReportGroups[0]?.inspectionPOItems ??
                      []
                    }
                    key="id"
                    expandable={{
                      expandedRowRender: (record) => {
                        const subRecords = record.subPoItems || [];
                        return (
                          <>
                            {subRecords.map((sub: any, sIndex: number) => {
                              return <SubPO key={sIndex} data={sub} />;
                            })}
                          </>
                        );
                      },
                      rowExpandable: () => true,
                      defaultExpandAllRows: true,
                      expandIcon: () => null
                    }}
                  ></SubTable>
                </div>
              );
            },
            expandIcon: ({ expanded, record, onExpand }) => {
              if (expanded) {
                return (
                  <UpOutlined
                    onClick={(e) => {
                      e.stopPropagation();
                      onExpand(record, e);
                    }}
                  />
                );
              }
              return (
                <DownOutlined
                  onClick={(e) => {
                    e.stopPropagation();
                    onExpand(record, e);
                  }}
                />
              );
            }
          }}
        ></Table>
      </Container>
    </div>
  );
};
